// @ts-expect-error pure js
import useAuthenticatedAxios from "./use-authenticated-axios";

export interface PreviewSuggestion {
  type: string | null;
  domaine: string | null;
  id_tenant: number | null;
  id_bien: number | null;
  id_property_folder: number | null;
  source: "finance_config" | "tenant_name" | "openai" | "manual" | "none";
}

export interface PreviewItem {
  tmp_id: string;
  date_transac: string;
  montant: number;
  description: string;
  external_id: string | null;
  suggestion: PreviewSuggestion;
}

export interface CommitBalanceInput {
  type: string;
  domaine: string;
  id_tenant?: number | null;
  id_bien?: number | null;
  id_property_folder?: number | null;
  comment?: string;
}

export interface CommitTransactionInput {
  date_transac: string;
  montant: number;
  description: string;
  external_id?: string | null;
  balance?: CommitBalanceInput | null;
}

export interface SkippedTransaction {
  date_transac: string;
  montant: number;
  description: string;
}

export interface CommitResult {
  created: number;
  skipped_duplicates: number;
  skipped_transactions: SkippedTransaction[];
  id_bank: number;
}

export default function useBankStatementImport() {
  const axios = useAuthenticatedAxios();

  async function preview(
    files: File[],
    idBank: number | null,
  ): Promise<PreviewItem[]> {
    const formData = new FormData();
    for (const file of files) {
      formData.append("file", file);
    }
    if (idBank !== null) {
      formData.append("id_bank", String(idBank));
    }
    const res = await axios.post("/bank-statement-imports/preview", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  }

  async function commit(payload: {
    id_bank: number | null;
    id_profile_nom: number | null;
    transactions: CommitTransactionInput[];
  }): Promise<CommitResult> {
    const res = await axios.post("/bank-statement-imports/commit", payload);
    return res.data;
  }

  return { preview, commit };
}
